<template>
    <el-dialog :title="(tableData.length == 0 && formData.edit? $t('Update Account Booking'):$t('Create Account Booking'))" :visible.sync="dialogFormVisible" :before-close="handleClose" @open="handleOpen('formData')" width="80%">
        <el-form label-position="top" :model="formData" ref="formData" class="demo-dynamic" :rules="rules">
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('Booking Date')" prop="booking_date">
                    <el-date-picker @change="copyBookingDate()" :disabled="formData.locked_booking_id != null" v-model="formData.booking_date" type="date" :placeholder="$t('Booking Date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('Document date')" prop="document_date">
                    <el-date-picker  :disabled="formData.locked_booking_id != null" v-model="formData.document_date" type="date" :placeholder="$t('Document date')" format="dd-MM-yyyy" value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <div class="summery-info">
                    <div class="sum-row">
                        <span>{{ $t('Debit') }}</span>
                        <span>{{ formData.booking_amount }}</span>
                    </div>
                    <div class="sum-row">
                        <span>{{ $t('Credit') }}</span>
                        <span>{{ formData.booking_amount }}</span>
                    </div>
                    <div class="sum-row">
                        <span>{{ $t('Total') }}</span>
                        <span>0.00</span>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" v-if="formData.receipt_number">
                <el-form-item :label="$t('Receipt No')" prop="receipt_number">
                    <el-input v-model="formData.receipt_number" :placeholder="$t('Receipt number')" disabled>
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('Debited from')" prop="debited_account_id">
                    <el-select v-model="formData.debited_account_id" :placeholder="$t('Debited from')" filterable clearable :disabled="formData.locked_booking_id != null">
                        <el-option v-for="(item) in debitAccountsList.data" v-if="formData.credited_account_id != item.id" :label="(item.account_number + ' - ' + item.account_name)" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('Credited to')" prop="credited_account_id">
                    <el-select v-model="formData.credited_account_id" :placeholder="$t('Credited to')" filterable clearable :disabled="formData.locked_booking_id != null">
                        <el-option v-for="(item) in creditAccountsList.data" v-if="formData.debited_account_id != item.id" :label="(item.account_number + ' - ' + item.account_name)" :key="item.id" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('Currency')" prop="currency_code">
                    <el-select v-model="formData.currency_code" :placeholder="$t('Select currency code')" :disabled="formData.locked_booking_id != null">
                        <el-option v-for="currency in getCurrencyList" :key="currency" :label="currency" :value="currency"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item :label="$t('Amount')" prop="booking_amount">
                    <!-- <el-input v-model="formData.booking_amount" :placeholder="$t('Booking Amount')" :disabled="formData.locked_booking_id != null">
                        <template slot="prepend">{{ $store.state.config.generalSettings.currency_code }}</template>
                    </el-input> -->
                    <div class="el-input el-input-group el-input-group--prepend">
                        <div class="el-input-group__prepend">{{ $store.state.config.generalSettings.currency_code }}</div>
                        <input v-model="formData.booking_amount" type="text" autocomplete="off" class="el-input__inner" :disabled="formData.locked_booking_id != null" 
                        v-mask="{'alias': 'numeric', 'groupSeparator': '\'', 'autoGroup': true, 'digits': 2, 'digitsOptional': false, 'prefix': '', 'placeholder': '0'}">
                    </div>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item :label="$t('Booking Text')" prop="booking_text">
                    <el-input type="textarea" v-model="formData.booking_text" :placeholder="$t('Booking Text')" :disabled="formData.locked_booking_id != null"></el-input>
                </el-form-item>
            </el-col>
            <el-col :lg="24" style="margin-top:20px;" v-if="tableData.length != 0 || !formData.edit">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('formData')" size="medium">{{ (formData.edit?
                        $t('Update list'):$t('Add to list')) }}</el-button>
                    <el-button type="cancel" @click="resetForm('formData')" size="medium">{{ $t('Reset') }}</el-button>
                </el-form-item>
            </el-col>
            <el-col :lg="24" v-if="tableData.length != 0 || !formData.edit">
                <el-table :data="tableData" style="width: 100%">
                    <el-table-column label="#" width="60">
                        <template slot-scope="scope">
                            <ul class="act-list">
                                <li>
                                    <a href="javascript:void(0);" @click="handleEdit(scope.$index, scope.row)"><i class="icon-edit"></i></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" @click="removeRow(scope.$index)"><i class=" icon-delete"></i></a>
                                </li>
                            </ul>
                        </template>
                    </el-table-column>
                    <el-table-column prop="booking_date" :label="$t('Booking Date')" width="200">
                        <template slot-scope="scope">
                            <span v-if="scope.row.booking_date" v-date-format="scope.row.booking_date"></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="document_date" :label="$t('Document date')" width="200">
                        <template slot-scope="scope">
                            <span v-if="scope.row.document_date" v-date-format="scope.row.document_date"></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="debited_account_id" :label="$t('Debited from')" width="140">
                        <template slot-scope="scope">
                            {{ getDebitAccNoFromId(scope.row.debited_account_id) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="credited_account_id" :label="$t('Credited to')" width="150">
                        <template slot-scope="scope">
                            {{ getCreditAccNoFromId(scope.row.credited_account_id) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="booking_text" :label="$t('Booking Text')" width="200">
                    </el-table-column>
                    <el-table-column prop="booking_amount" :label="$t('Amount')" width="100">
                        <template slot-scope="scope">
                            <span v-cformat="scope.row.booking_amount"></span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="currency_code" :label="$t('Currency')" width="100">
                    </el-table-column>
                    <el-table-column label=" " min-width="10"></el-table-column>
                </el-table>
            </el-col>
            <el-col :lg="24" style="margin-top:20px;">
                <el-form-item>
                    <el-button type="primary" @click="saveForm('formData')" size="medium" :disabled="formData.locked_booking_id != null">{{ $t('Save') }}</el-button>
                    <el-button type="cancel" @click="$emit('popup',false)" size="medium">{{ $t('Close') }}</el-button>
                </el-form-item>
            </el-col>
            <img :src="'/static/kipaki-icon.svg'" alt="hand-icon" class="icon-bg" />
        </el-form>
    </el-dialog>
</template>

<script>
    export default {
        props: {
            dialogFormVisible: Boolean,
            rowData: Object
        },
        mounted() {
            this.getDebitAccounts()
            this.getCreditAccounts()
        },
        data() {
            var validatePass = (rule, value, callback) => {
                if (!this.formData.debited_account_id && !this.formData.credited_account_id) {
                    callback(new Error('Please select debit account or credit account'));
                } else {
                    this.$refs.formData.clearValidate('credited_account_id');
                    this.$refs.formData.clearValidate('debited_account_id');
                    callback();
                }
            };
            return {
                datePickerOptions: {
                    disabledDate(date) {
                        return date > new Date()
                    }
                },
                formData: {
                    currency_rate: '1.00',
                    currency_code: this.$store.state.config.generalSettings.currency_code,
                    document_date: null,
                    credited_account_id: null,
                    debited_account_id: null,   
                    booking_amount: 0
                },
                tableData: [],
                formLabelWidth: '120px',
                rules: {
                    'booking_date': [{
                        required: true,
                        message: this.$t('This field is required')
                    }],
                    'document_date': [{
                        required: true,
                        message: this.$t('This field is required')
                    }],
                    'currency_code': [{
                        required: true,
                        message: this.$t('This field is required')
                    }],
                    'debited_account_id': [{
                        validator: validatePass,
                        trigger: ['blur', 'change']
                    }],
                    'credited_account_id': [{
                        validator: validatePass,
                        trigger: ['blur', 'change']
                    }],                    
                    'booking_amount': [{
                        required: true,
                        message: this.$t('This field is required'),
                        trigger: ['blur']
                    }],
                    'booking_text': [{
                        required: true,
                        message: this.$t('This field is required')
                    }]
                },
                getCurrencyList: process.env.KIPAKI_currency_list,
                debitAccountsList: {},
                creditAccountsList: {}
            };
        },
        methods: {
            getDebitAccounts() {
                request({
                    url: "get-all-accounts",
                    method: "get",
                    params: {'type' : 'debit'}
                }).then(response => {
                    this.debitAccountsList = response.data;
                });
            },
            getCreditAccounts() {
                request({
                    url: "get-all-accounts",
                    method: "get",
                    params: {'type' : 'credit'}
                }).then(response => {
                    this.creditAccountsList = response.data;
                });
            },
            getDebitAccNoFromId(id) {
                if (!id)
                    return;
                return this.debitAccountsList.data.filter((item) => {
                    return item.id == id;
                })[0].account_number;
            },
            getCreditAccNoFromId(id) {
                if (!id)
                    return;
                return this.creditAccountsList.data.filter((item) => {
                    return item.id == id;
                })[0].account_number;
            },
            handleOpen() {
                this.tableData = [];
                this.formData = Object.assign({}, this.rowData);
                this.$nextTick(() => {
                    this.$refs['formData'].clearValidate();
                })
            },
            handleClose() {
                this.$emit('popup', false)
            },
            handleEdit(i, formData) {
                this.formData = Object.assign({}, formData);
                this.formData.edit = true;
                this.formData.index = i;
            },
            updateRow(formName, row) {
                this.tableData.forEach((item, i) => {
                    if (i == row.index) {
                        const index = this.tableData.indexOf(item)
                        this.tableData.splice(index, 1, row)
                    }
                });
                this.resetForm(formName);
            },
            removeRow(i) {
                let rows = this.tableData;
                rows = rows.filter(function (item, key) {
                    return key !== i;
                });
                this.tableData = rows;
            },
            submitForm(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (this.formData.edit) {
                            this.updateRow(formName, Object.assign({}, this.formData));
                        } else {
                            this.tableData.push(Object.assign({}, this.formData));
                            this.$refs[formName].resetFields();
                        }
                    }
                });
            },
            updateData(row) {
                return request({
                        url: "account-bookings/" + row.id,
                        method: "PATCH",
                        data: row
                    })
                    .then(response => {
                        this.$emit('popupupdate', response.data.data);
                        this.$emit('popup', false);
                        this.$notify({
                            title: this.$t('Success'),
                            message: response.data.message,
                            type: "success",
                            offset: 50
                        });
                    })
                    .catch(error => {
                        this.$notify({
                            title: this.$t('Error'),
                            message: error.response.data.message,
                            type: "error",
                            offset: 50
                        });
                    });
            },
            saveForm(formName) {
                if (this.formData.edit && this.formData.id) {
                    this.$refs[formName].validate(valid => {
                        if (valid) {
                            return this.updateData(this.formData);
                        }
                    });
                } else {
                    if (this.tableData.length == 0) {
                        return this.$notify({
                            title: this.$t('Error'),
                            message: this.$t('Currently no any transactions are added in list.'),
                            type: "error",
                            offset: 50
                        });
                    }
                    return request({
                            url: "account-bookings",
                            method: "POST",
                            data: {
                                transactions: this.tableData
                            }
                        })
                        .then(response => {
                            this.$emit('popup', false);
                            this.$emit('popupsave', false);
                            this.$notify({
                                title: this.$t('Success'),
                                message: response.data.message,
                                type: "success",
                                offset: 50
                            });
                        })
                        .catch(error => {
                            this.$notify({
                                title: this.$t('Error'),
                                message: error.response.data.message,
                                type: "error",
                                offset: 50
                            });
                        });
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.formData.edit = false;
            },
            copyBookingDate() {
                if (!this.formData.document_date && this.formData.booking_date) {
                    this.formData.document_date = this.formData.booking_date;
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/AccountBookings/Form.vue